// this is an autogenerated file from App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Footer/MoveAction/Content/Stages/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_TaskOverlay_Content_Content_Footer_MoveAction_Content_Stages($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id }, done: { _eq: false } }
    order_by: { order: asc }
  ) {
    id
    name
  }
}

`